import { ConfigProps } from '@config/types'

const config = ({}: ConfigProps) =>
  ({
    leserreporterPageUrl:
      '/schweiz/werde-leserreporter-in-schicke-uns-deine-videos-fotos-und-inputs-blick-will-deine-story-id17849625.html',
  }) as const satisfies Record<string, unknown>

export default config
